<div class="custom-modal-backdrop" *ngIf="isVisible" (click)="onClose()">
  <!-- Stop propagation prevents clicking the white box from closing the modal -->
  <div class="custom-modal-card text-center" (click)="$event.stopPropagation()">
    
    <!-- Close Cross Button Button -->
    <button class="btn-close-cross" (click)="onClose()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
<div class="success-icon-wrapper d-flex align-items-center justify-content-center mx-auto">
  <div class="checkmark-circle"></div>
</div>

    <!-- Main Message Heading -->
    <h3 class="modal-main-title mt-4">Workshop Request Submitted</h3>

    <!-- Sub description status messages -->
    <p class="modal-light-desc mt-3">
      Your workshop request has been successfully <br> received and is now under review.
    </p>

    <!-- Reference Context Blocks Layout -->
    <div class="metadata-block-group mt-4">
      <p class="meta-line">
        <span class="meta-label">Reference ID:</span> 
        <span class="meta-value text-muted-dark font-monospace">{{ referenceId }}</span>
      </p>
      
      <p class="meta-line mt-2">
        <span class="meta-label">Expected response:</span> 
        <span class="meta-value">{{ expectedResponse }}</span>
      </p>
    </div>

    <!-- Notification confirmation target string line -->
    <p class="confirmation-email-notice mt-4">
      A confirmation email has been sent to: <br>
      <span class="user-target-email font-semibold">{{ userEmail }}</span>
    </p>

    <!-- Primary Action Button -->
    <div class="action-btn-row mt-4">
      <button class="btn-modal-close" (click)="onClose()">Close</button>
    </div>

  </div>
</div>
